if ( typeof ShippingNotice !== 'function' ) {

  class ShippingNotice extends HTMLElement {

    constructor() {
      super();
      this.init();
    }

	/* 
    init() {

      const freeShippingThreshold = Number(this.getAttribute('data-free-shipping'));
      const cartTotal = Number(this.getAttribute('data-cart-total-amount'));
      const freeShippingRemaining = cartTotal - Math.round(freeShippingThreshold * (Shopify.currency.rate ? Number(Shopify.currency.rate) : 1));
      let shippingMessage = '';
      let shippingSuccess = false

      if ( freeShippingRemaining < 0 ) {
        shippingMessage = window.KROWN.settings.locales.shipping_notice_remaining_to_free.replace('{{ remaining_amount }}', this._formatMoney(Math.abs(freeShippingRemaining), KROWN.settings.shop_money_format));

      } else {
        shippingMessage = window.KROWN.settings.locales.shipping_notice_eligible_for_free;
        shippingSuccess = true;
      }

      if ( this.hasAttribute('data-show-alert') ) {
        this.innerHTML = `
          <div class="alert alert--wide alert--${shippingSuccess ? 'success' : 'note'}">
            ${shippingMessage}
          </div>`;
      } else {
        this.innerHTML = shippingMessage;
      }

    }
	*/



	/*
	Free Shipping Progress Notice
	Displays a dynamic free shipping message and progress bar in the cart drawer.
	Behaviour:
		- Empty cart: shows the free shipping threshold.
		- Below threshold: shows the remaining amount needed for free shipping.
		- Threshold reached: shows a success message.
	
	The truck icon moves along the progress bar based on the cart total.
	Progress is capped at 100% once free shipping has been achieved.
	*/
	init() {
		const freeShippingThreshold = Number(this.getAttribute('data-free-shipping'));
		const cartTotal = Number(this.getAttribute('data-cart-total-amount'));

		const threshold = Math.round(
			freeShippingThreshold * (Shopify.currency.rate ? Number(Shopify.currency.rate) : 1)
		);

		const remaining = threshold - cartTotal;
		const progress = Math.min((cartTotal / threshold) * 100, 100);

		let shippingMessage = ''
		const shippingSuccess = cartTotal > 0 && remaining <= 0;

		if (cartTotal <= 0) {
			shippingMessage = this.getTranslatedMessage('data-text-empty', 'Free shipping over __amount__', this.formatRemaining(threshold));
		} else if (remaining > 0) {
			shippingMessage = this.getTranslatedMessage('data-text-remaining', 'You are __amount__ away from free shipping', this.formatRemaining(remaining));
		} else {
			shippingMessage = this.getTranslatedMessage('data-text-success', 'You have reached free shipping!', '');
		}

		this.innerHTML = `
			<div class="shipping-progress${shippingSuccess ? ' shipping-progress--success' : ''}">
				<p class="shipping-progress__text">${shippingMessage}</p>

				<div class="shipping-progress__bar">
					<div class="shipping-progress__fill" style="width: ${progress}%"></div>

					<div 
						class="shipping-progress__icon shipping-progress__icon--truck"
						style="left: ${progress}%"
						data-appsalon-free-shipping-truck
					>
						🚚
					</div>
				</div>
			</div>
		`;

		this._maybeCelebrateTruck(shippingSuccess);
	}

	/*
	Runs the truck animation when the global free-shipping celebration script has
	marked an active celebration window. This fixes cases where the cart drawer is
	re-rendered after the global script first tried to add the animation class.
	*/
	_maybeCelebrateTruck(shippingSuccess) {
		if (!shippingSuccess) return;

		const celebrateUntil = Number(window.AppsalonFreeShippingCelebrateUntil || 0);
		if (!celebrateUntil || Date.now() > celebrateUntil) return;

		const truck = this.querySelector('[data-appsalon-free-shipping-truck]');
		const progress = this.querySelector('.shipping-progress');
		if (!truck) return;

		window.requestAnimationFrame(() => {
			if (progress) {
				progress.classList.remove('appsalon-shipping-progress-celebrate');
				void progress.offsetWidth;
				progress.classList.add('appsalon-shipping-progress-celebrate');
			}

			truck.classList.remove('appsalon-shipping-truck-celebrate');
			void truck.offsetWidth;
			truck.classList.add('appsalon-shipping-truck-celebrate');

			window.setTimeout(() => {
				truck.classList.remove('appsalon-shipping-truck-celebrate');
				if (progress) {
					progress.classList.remove('appsalon-shipping-progress-celebrate');
				}
			}, 1900);
		});
	}


	getTranslatedMessage(attributeName, fallback, amount) {
		const template = this.getAttribute(attributeName) || fallback;

		return template.replace(/__amount__/g, amount || '');
	}

	/*
	Formats an amount in cents to Norwegian currency.
	
	Examples:
	25000 -> 250 kr
	25050 -> 250,50 kr
	999   -> 9,99 kr
	
	Unlike Shopify's default money formatter, this only shows decimals when they are actually needed.
	*/
	formatRemaining(cents) {
		const amount = Number(cents) / 100;

		const formattedAmount = new Intl.NumberFormat('nb-NO', {
			minimumFractionDigits: amount % 1 === 0 ? 0 : 2,
			maximumFractionDigits: 2
		}).format(amount);

		return `Kr ${formattedAmount},-`;
	}


    
    _formatMoney(cents, format) {

			if (typeof cents === 'string') {
				cents = cents.replace('.', '');
			}
	
			let value = '';
			const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
			const formatString = format || moneyFormat;
	
			function formatWithDelimiters(number, precision, thousands, decimal) {
				thousands = thousands || ',';
				decimal = decimal || '.';
	
				if (isNaN(number) || number === null) {
					return 0;
				}
	
				number = (number / 100.0).toFixed(precision);
	
				const parts = number.split('.');
				const dollarsAmount = parts[0].replace(
					/(\d)(?=(\d\d\d)+(?!\d))/g,
					'$1' + thousands
				);
				const centsAmount = parts[1] ? decimal + parts[1] : '';
	
				return dollarsAmount + centsAmount;
			}
	
			switch (formatString.match(placeholderRegex)[1]) {
				case 'amount':
					value = formatWithDelimiters(cents, 2);
					break;
				case 'amount_no_decimals':
					value = formatWithDelimiters(cents, 0);
					break;
				case 'amount_with_comma_separator':
					value = formatWithDelimiters(cents, 2, '.', ',');
					break;
				case 'amount_no_decimals_with_comma_separator':
					value = formatWithDelimiters(cents, 0, '.', ',');
					break;
				case 'amount_no_decimals_with_space_separator':
					value = formatWithDelimiters(cents, 0, ' ');
					break;
				case 'amount_with_apostrophe_separator':
					value = formatWithDelimiters(cents, 2, "'");
					break;
			}
	
			return formatString.replace(placeholderRegex, value);
	
		}

  }

  if ( typeof customElements.get('shipping-notice') == 'undefined' ) {
    customElements.define('shipping-notice', ShippingNotice);
  }

}